import { Icon } from '@ps/isp-web-component-library';
import { ChevronMediumDown } from '@ps/isp-web-component-library/icons/ChevronMediumDown';
import type { MarketId, MeetingBasedMarketView } from '@ps/isp-web-services-types';
import type { Values } from '@ps/web-core-intl';
import { Link, Translation } from '@ps/web-shared-components';
import React from 'react';
import { useSelector } from 'react-redux';

import type { RootState } from '@swf/core/store';
import FormattedDateTime from '@swf/sports/components/FormattedDateTime/FormattedDateTime';
import RaceDetails from '@swf/sports/components/RaceDetails/RaceDetails';

import { useSportsNextRacesWidget } from '../model';

import { TXTWCL_Each_Way, TXTWCL_N0_odds___N1_places } from './RaceInfo.messages.json';
import styles from './RaceInfo.scss';

interface Props {
  marketId: MarketId;
}

const RaceInfo: React.FC<Props> = ({ marketId }) => {
  const { widgetSelect } = useSportsNextRacesWidget();

  const { meetingId, placeTerms, raceId } = useSelector(
    (state: RootState) => widgetSelect.market(state, marketId) as MeetingBasedMarketView
  );
  const { startTime, details } = useSelector((state: RootState) =>
    widgetSelect.race(state, raceId)
  );
  const { venue } = useSelector((state: RootState) => widgetSelect.meeting(state, meetingId));
  const raceCardLinkValues = useSelector((state: RootState) =>
    widgetSelect.raceCardLinkValues(state, marketId)
  );

  return (
    <div className={styles.raceInfo}>
      <Link
        className={styles.raceLink}
        alias="sportsAnimalRacingRace"
        values={raceCardLinkValues as unknown as Values}
      >
        <span className={styles.race}>
          <span className={styles.time}>{<FormattedDateTime date={startTime} />}</span>
          {venue}
          {details ? <RaceDetails details={details} /> : null}
        </span>

        <Icon icon={ChevronMediumDown} className={styles.chevron} size="x1" />
      </Link>
      {placeTerms && placeTerms.numPlaces ? (
        <div className={styles.eachWay}>
          <Translation {...TXTWCL_Each_Way} />{' '}
          <Translation
            {...TXTWCL_N0_odds___N1_places}
            values={{
              deductionFraction: placeTerms.deductionFraction,
              numPlaces: placeTerms.numPlaces
            }}
          />
        </div>
      ) : null}
    </div>
  );
};

export default RaceInfo;
